var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 7.5C9.33663 7.5 8.70075 7.76339 8.23191 8.23223C7.76307 8.70107 7.49967 9.33696 7.49967 10C7.49967 10.663 7.76307 11.2989 8.23191 11.7678C8.70075 12.2366 9.33663 12.5 9.99967 12.5C10.6627 12.5 11.2986 12.2366 11.7674 11.7678C12.2363 11.2989 12.4997 10.663 12.4997 10C12.4997 9.33696 12.2363 8.70107 11.7674 8.23223C11.2986 7.76339 10.6627 7.5 9.99967 7.5ZM9.99967 14.1667C8.89461 14.1667 7.8348 13.7277 7.0534 12.9463C6.272 12.1649 5.83301 11.1051 5.83301 10C5.83301 8.89493 6.272 7.83512 7.0534 7.05372C7.8348 6.27232 8.89461 5.83333 9.99967 5.83333C11.1047 5.83333 12.1646 6.27232 12.946 7.05372C13.7274 7.83512 14.1663 8.89493 14.1663 10C14.1663 11.1051 13.7274 12.1649 12.946 12.9463C12.1646 13.7277 11.1047 14.1667 9.99967 14.1667ZM9.99967 3.75C5.83301 3.75 2.27467 6.34167 0.833008 10C2.27467 13.6583 5.83301 16.25 9.99967 16.25C14.1663 16.25 17.7247 13.6583 19.1663 10C17.7247 6.34167 14.1663 3.75 9.99967 3.75Z",
    fill: "#14917D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/Eye-Icon.992dd3c3128860f08759c2c57dbfbfaa.svg";
export { ForwardRef as ReactComponent };